import React from 'react'
import SYMBOL_YELLOW_GIVU from '../../styles/images/symbol_yellow.png'
import { useNavigate } from 'react-router-dom'

const SymbolLogoImg = () => {
  const navigate = useNavigate()
  return (
    <img src={SYMBOL_YELLOW_GIVU} alt="Logo Image" className='mx-4 my-2 hover:cursor-pointer' onClick={()=>navigate('/')} width={50}/>
  )
}

export default SymbolLogoImg